import Producer from '@/types/Producer'
import { useAdminFilter } from './adminFilter'

export function useFilters() {
  const admin = (producer: Producer) => useAdminFilter(producer)

  return { admin }
}
